import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
// import About from "../views/About.vue";
import Login from "../views/Login.vue";
// import Register from "../views/Register.vue";
// import Questions from "../views/Questions.vue";
// import Results from "../views/Results.vue"
import Layout from "../components/Layout.vue";
import GLYF_PainPoint from "../components/Layout_GLYF_pain_point.vue";
import GLYF_UserCenter from "../components/Layout_GLYF_user_center.vue";
import GLYF_Mgmt from "../components/Layout_GLYF_admin.vue";
import GLYF_Login from "../components/Layout_GLYF_login.vue";
import GLYF_PainPoint_Article from "../views/PainSpotArticle.vue";
import GLYF_PainPoint_Main from "../views/PainSpotMain.vue";
import GLYF_User_Data from "../views/GLYFUserCenter/GLYF_User_Data.vue";
import GLYF_User_Favorites from "../views/GLYFUserCenter/GLYF_User_Favorites.vue";
import GLYF_User_Questions from "../views/GLYFUserCenter/GLYF_User_Questions.vue";
import GLYF_User_Contents from "../views/GLYFUserCenter/GLYF_User_Contents.vue";
import GLYF_Tobe_Expert from "../views/GLYFUserCenter/GLYF_Tobe_Expert.vue";
import GLYF_User_Mgmt from "../views/GLYFMgmt/GLYF_User_Mgmt.vue";
import GLYF_PainSpot_Mgmt from "../views/GLYFMgmt/GLYF_PainSpot_Mgmt.vue";
import GLYF_Question_Review from "../views/GLYFMgmt/GLYF_Question_Review.vue";
import GLYF_Amendment_Review from "../views/GLYFMgmt/GLYF_Amendment_Review.vue";
import GLYF_Expert_Approve from "../views/GLYFMgmt/GLYF_Expert_Approve.vue";
import GLYF_Share from "../components/Layout_GLYF_share.vue";
import GLYF_Expert from "../components/Layout_GLYF_expert.vue";
import MyAss from "../views/MyAssessment/MyAssessment.vue";
import JKMyAss from "../views/MyAssessment/MyAssessment_JianKang.vue";
import RCMyAss from "../views/MyAssessment/MyAssessment_RC.vue";
import ChengShu from "../views/QuestionManagement/ChengShu.vue";
import JianKang from "../views/QuestionManagement/JianKang.vue";
import RenCai from "../views/QuestionManagement/RC.vue";
// import ChengShu_Todo from "../views/MyAssessment/ChengShu_todo.vue";
// import JianKang_Todo from "../views/MyAssessment/JianKang_todo.vue";
// import Progress from "../views/ProgressTracking/ProgressTracking.vue";
// import ChengShu_Progress from "../views/ProgressTracking/ChengShu_progress.vue";
// import Results from "../views/AssessResults/MyTakePartIn.vue";
import Tasks from "../views/QuestionManagement/ChengShu_taskmana.vue";
import JKTasks from "../views/QuestionManagement/JianKang_taskmana.vue";
// import ChengShu_TakePartIn from "../views/AssessResults/ChengShu_MyTakePartIn.vue";
// import JianKang_TakePartIn from "../views/AssessResults/JianKang_MyTakePartIn.vue";
// import MyOwnResults from "../views/AssessResults/MyOwnResults.vue";
// import ChengShu_OwnResults from "../views/AssessResults/ChengShu_OwnResults.vue";
// import VideoPlayer from "../views/VideoTest.vue";
import NF from "../components/NotFound.vue";
// import Report from "../views/MonthReport.vue";
import Company from "../views/CompanyUserDownload.vue";
import LoginJK from "../views/Login_JianKang.vue";
import LoginRC from "../views/Login_RC.vue";
import JK from "../components/Layout_JianKang.vue";
import RC from "../components/Layout_RC.vue";
import JKDataCenter from "../views/QuestionManagement/JianKang_DataCenter.vue";
import JKCompany from "../views/JKCompanyUserDownload.vue";
import RCTasks from "../views/QuestionManagement/RC_taskmana.vue";
import RCReports from "../views/AssessResults/RC_report_center.vue";
import AutoAnswer from "../views/AutoAnswer.vue";
import AutoTest from "../views/MultiAutoTest.vue";
import SysConfig from "../views/SysConfig.vue";
import MyAssTask from "../views/MyAssTask.vue";
import MyJKAssTask from "../views/MyAssTask.vue";
import MyRCAssTask from "../views/MyAssTask.vue";

Vue.use(VueRouter);
// 这里重写push方法（replace方法同理），重点就是后面的.catch(err => err) 用来捕获并隐藏报错。
// 在首页进行注销并跳转至首页时，因为前后是相同的路由，此时命令行会抛错，这里处理后就隐藏了报错。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: "/report",
  //   name: "Report",
  //   component: Report,
  //   // component: () => import('../views/Login.vue'),
  // },
  {
    path: "/login",
    name: "Login",
    component: Login,
    // component: () => import('../views/Login.vue'),
  },
  {
    path: "/JKlogin",
    name: "LoginJK",
    component: LoginJK,
    // component: () => import('../views/Login.vue'),
  },
  {
    path: "/RClogin",
    name: "LoginRC",
    component: LoginRC,
    // component: () => import('../views/Login.vue'),
  },
  {
    path: "/glyf",
    name: "GLYF_PainPoint",
    redirect: '/glyf/main',
    component: GLYF_PainPoint,
    // component: () => import('../views/Login.vue'),
    children: [
      {
        path: "/glyf/main",
        name: "GLYF_PainPoint_Main",
        component: GLYF_PainPoint_Main,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '痛点列表'},        
      },
      {
        path: "/glyf/painspot",
        name: "GLYF_PainPoint_Article",
        component: GLYF_PainPoint_Article,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '痛点详情'},        
      },
      {
        path: "/glyf/expert",
        name: "GLYF_Expert",
        component: GLYF_Expert,
      },
    ]
  },
  {
    path: "/glyf_login",
    name: "GLYF_Login",
    component: GLYF_Login,
  },
  {
    path: "/glyf_share",
    name: "GLYF_Share",
    component: GLYF_Share,
  },
  {
    path: "/glyf_user_center",
    name: "GLYF_UserCenter",
    redirect: '/glyf_user_center/my_profile',
    component: GLYF_UserCenter,
    // component: () => import('../views/Login.vue'),
    children: [
      {
        path: "/glyf_user_center/my_profile",
        name: "GLYF_User_Data",
        component: GLYF_User_Data,
      },
      {
        path: "/glyf_user_center/my_favorites",
        name: "GLYF_User_Favorites",
        component: GLYF_User_Favorites,
      },
      {
        path: "/glyf_user_center/my_questions",
        name: "GLYF_User_Questions",
        component: GLYF_User_Questions,
      },
      {
        path: "/glyf_user_center/my_contents",
        name: "GLYF_User_Contents",
        component: GLYF_User_Contents,
      },
      {
        path: "/glyf_user_center/tobe_expert",
        name: "GLYF_Tobe_Expert",
        component: GLYF_Tobe_Expert,
      },
    ]
  },
  {
    path: "/glyf_mgmt",
    name: "GLYF_Mgmt",
    redirect: '/glyf_mgmt/user_mgmt',
    component: GLYF_Mgmt,
    // component: () => import('../views/Login.vue'),
    children: [
      {
        path: "/glyf_mgmt/user_mgmt",
        name: "GLYF_User_Mgmt",
        component: GLYF_User_Mgmt,
      },
      {
        path: "/glyf_mgmt/painspot_mgmt",
        name: "GLYF_PainSpot_Mgmt",
        component: GLYF_PainSpot_Mgmt,
      },
      {
        path: "/glyf_mgmt/question_review",
        name: "GLYF_Question_Review",
        component: GLYF_Question_Review,
      },
      {
        path: "/glyf_mgmt/amendment_review",
        name: "GLYF_Amendment_Review",
        component: GLYF_Amendment_Review,
      },
      {
        path: "/glyf_mgmt/expert_approve",
        name: "GLYF_Expert_Approve",
        component: GLYF_Expert_Approve,
      },
    ]
  },
  {
    path: "/RC",
    name: "RC",
    component: RC,
    // redirect: '/RC/myass',
    // redirect: '/JK/myass',
    // component: () => import('../views/Login.vue'),
    children: [
      {
        path: "/RC/myass",
        name: "RCMyAss",
        component: RCMyAss,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '我的任务'},        
      },
      {
        path: "/RC/mytask",
        name: "MyRCAssTask",
        component: MyRCAssTask,
      },
      {
        path: "/RC/tasks",
        name: "RCTasks",
        component: RCTasks,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '任务管理'},        
      },
      {
        path: "/RC/taskmgmt",
        name: "RCTaskMgmt",
        component: RenCai,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '任务管理'},
      },
      {
        path: "/RC/reportCenter",
        name: "RCReports",
        component: RCReports,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '报表中心'},
      },
      {
        path: "/RC/autotest",
        name: "AutoTest",
        component: AutoTest,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '自动化批量测试'},
      },
      {
        path: "/RC/sysconf",
        name: "SysConfig",
        component: SysConfig,
        meta: {title: '系统设置'},
      },
    ]
  },
  {
    path: "/JK",
    name: "JK",
    component: JK,
    // redirect: '/JK/myass',
    // component: () => import('../views/Login.vue'),
    children: [
      {
        path: "/JK/myass",
        name: "JKMyAss",
        component: JKMyAss,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '我的任务'},        
      },
      {
        path: "/JK/mytask",
        name: "MyJKAssTask",
        component: MyJKAssTask,
      },
      {
        path: "/JK/tasks",
        name: "JKTasks",
        component: JKTasks,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '任务管理'},        
      },
      {
        path: "/JK/taskmgmt",
        name: "JKTaskMgmt",
        component: JianKang,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '任务管理'},
      },
      {
        path: "/JK/dataCenter",
        name: "JKDataCenter",
        component: JKDataCenter,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '数据中心'},
      },
      {
        path: "/JK/company",
        name: "JKCompany",
        component: JKCompany,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '企业用户中心'},
      },
      {
        path: "/JK/autotest",
        name: "AutoTest",
        component: AutoTest,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '自动化批量测试'},
      },
      {
        path: "/JK/sysconf",
        name: "SysConfig",
        component: SysConfig,
        meta: {title: '系统设置'},
      },
    ]
  },
  // {
  //   path: "/regist",
  //   name: "Register",
  //   component: Register,
  // },
  {
    path: "/",
    name: "Layout",
    component: Layout,
    // component: () => import('../components/Layout.vue'),
    redirect: '/myass',
    children: [
      {
        path: "/myass",
        name: "MyAss",
        component: MyAss,
        // component: () => import('../views/MyAssessment/MyAssessment.vue'),
        meta: {title: '我的评估'},
      },
      {
        path: "/mytask",
        name: "MyAssTask",
        component: MyAssTask,
      },
      {
        path: "/taskmgmt",
        name: "TaskMgmt",
        component: ChengShu,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '任务管理'},
      },
      {
        path: "/company",
        name: "Company",
        component: Company,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '企业用户中心'},
      },
      {
        path: "/jiankang",
        name: "JianKang",
        component: JianKang,
        meta: {title: '组织健康度测评'},
      },
      {
        path: "/sysconf",
        name: "SysConfig",
        component: SysConfig,
        meta: {title: '系统设置'},
      },
      // {
      //   path: "/progress",
      //   name: "Progress",
      //   component: Progress,
      //   meta: {title: '进度跟踪'},
      // },
      // {
      //   path: "/results",
      //   name: "Results",
      //   component: Results,
      //   meta: {title: '评估结果'},
      // },
      {
        path: "/tasks",
        name: "Tasks",
        component: Tasks,
        // component: () => import('../views/QuestionManagement/ChengShu_taskmana.vue'),
        meta: {title: '任务管理'},        
      },
      {
        path: "/auto_answer",
        name: "AutoAnswer",
        component: AutoAnswer,
      },
      // {
      //   path: "/video_player",
      //   name: "VideoPlayer",
      //   component: VideoPlayer,
      // },
      {
        path: "/autotest",
        name: "AutoTest",
        component: AutoTest,
        // component: () => import('../views/QuestionManagement/ChengShu.vue'),
        meta: {title: '自动化批量测试'},
      },
    ]
  },
  // 设置404页面的路由
  {
    path: "/404",
    name: "notFound",
    component: NF,   
    // component: () => import('../components/NotFound.vue'),     
  },
  {
    path: "*",
    redirect: "/404"
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition){
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  }
});

export default router;
